import { render } from "./ChangeMdp.vue?vue&type=template&id=70a4de4e&scoped=true"
import script from "./ChangeMdp.vue?vue&type=script&lang=js"
export * from "./ChangeMdp.vue?vue&type=script&lang=js"

import "./ChangeMdp.vue?vue&type=style&index=0&id=70a4de4e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a4de4e"]])

export default __exports__